import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--export" icon='export'>{ children ? children : 'Export' }</Button>
}